import { MedioDePago } from 'src/app/pago/enums/MedioDePago.enum';
import { Descuento } from 'src/app/pago/models/Descuento.model';
import { Pagador } from 'src/app/pago/models/Pagador.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { TarjetaDeCredito } from 'src/app/pago/models/TarjetaDeCredito.model';

export class PagoBuilder {
  private idPago?: string;
  private renovacionAutomatica?: boolean;
  private medioPago?: MedioDePago;
  private tarjetaCredito?: TarjetaDeCredito;
  private descuentosAplicados?: Descuento[] = [];
  private total?: number;
  private subTotal?: number;
  private totalDescuentos?: number;
  private estadoPago?: string;
  private pagador?: Pagador = null;
  private medioPagoSeleccionado: string;
  private nombreProducto: string;

  withIdPago(idPago: string) {
    this.idPago = idPago;
    return this;
  }

  withRenovacionAutomatica(renovacionAutomatica: boolean) {
    this.renovacionAutomatica = renovacionAutomatica;
    return this;
  }

  withTMedioPago(medioPago: MedioDePago) {
    this.medioPago = medioPago;
    return this;
  }

  withTarjetaCredito(tarjetaCredito: TarjetaDeCredito) {
    this.tarjetaCredito = tarjetaCredito;
    return this;
  }

  withPagador(pagador: Pagador) {
    this.pagador = pagador;
    return this;
  }

  withDescuentosAplicados(descuentosAplicados: any[]) {
    this.descuentosAplicados = descuentosAplicados;
    return this;
  }

  withTotal(total: number) {
    this.total = total;
    return this;
  }

  withSubTotal(subTotal: number) {
    this.subTotal = subTotal;
    return this;
  }

  withTotalDescuentos(totalDescuentos: number) {
    this.totalDescuentos = totalDescuentos;
    return this;
  }

  withEstadoPago(estadoPago: string) {
    this.estadoPago = estadoPago;
    return this;
  }

  withMedioPagoSeleccionado(medioPagoSeleccionado: string) {
    this.medioPagoSeleccionado = medioPagoSeleccionado;
    return this;
  }

  withNombreProducto(nombreProducto: string) {
    this.nombreProducto = nombreProducto;
    return this;
  }

  build(): Pago {
    return {
      idPago: this.idPago,
      renovacionAutomatica: this.renovacionAutomatica,
      medioPago: this.medioPago,
      tarjetaCredito: this.tarjetaCredito,
      pagador: this.pagador,
      descuentosAplicados: this.descuentosAplicados,
      total: this.total,
      subTotal: this.subTotal,
      totalDescuentos: this.totalDescuentos,
      estadoPago: this.estadoPago,
      medioPagoSeleccionado: this.medioPagoSeleccionado,
      nombreProducto: this.nombreProducto,
    };
  }
}
